import { Box, Typography, styled } from '@mui/material';

export const ProjectsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  padding: theme.spacing(3, 5),
  height: '100%',
  [theme.breakpoints.down('md')]: {
    paddingTop: theme.spacing(5),
  },
}));

export const Header = styled(Typography)(({ theme }) => ({
  fontSize: 32,
  fontStyle: 'normal',
  fontWeight: 500,
  marginBottom: theme.spacing(5),
}));
